import React from 'react';
import { FormikProps } from 'formik';
import { Modal } from '../../../components';
import { Checkbox } from '../../../components/primitives';
import { IProductInitialValuesProps } from '../types';

interface FullReviewModalProps {
  props: FormikProps<IProductInitialValuesProps>;
  showFullReviewModal: boolean;
  setShowFullReviewModal: (_show: boolean) => void;
  disableProductUntilChangesAccepted: boolean;
  setDisableProductUntilChangesAccepted: (_disable: boolean) => void;
}

export const FullReviewModal: React.FC<FullReviewModalProps> = ({
  props,
  showFullReviewModal,
  setShowFullReviewModal,
  disableProductUntilChangesAccepted,
  setDisableProductUntilChangesAccepted,
}) => {
  return (
    <Modal
      open={showFullReviewModal}
      onClose={() => {
        setShowFullReviewModal(false);
      }}
      title="Product Review Required"
      footer={true}
      primaryAction={{
        label: 'Save',
        variant: 'primary',
        onClick: () => {
          setShowFullReviewModal(false);
          props.handleSubmit();
        },
      }}
      secondaryActions={{
        label: 'Dismiss',
        variant: 'outline',
        onClick: () => {
          setShowFullReviewModal(false);
        },
      }}
    >
      <div>
        <p className="mb-4">All changes will be pending review. This includes changes to available quantities.</p>
        <p className="mb-4">You can make your product inactive until the changes are accepted below:</p>
        <div className="mb-4 ml-4">
          <div className="flex items-center gap-2">
            <Checkbox
              id="full-review-disable-until-accepted"
              checked={disableProductUntilChangesAccepted}
              onCheckedChange={() => {
                setDisableProductUntilChangesAccepted(!disableProductUntilChangesAccepted);
              }}
            />
            <label
              htmlFor="full-review-disable-until-accepted"
              className="cursor-pointer select-none text-sm text-foreground"
            >
              Disable product until changes are accepted
            </label>
          </div>
        </div>
      </div>
    </Modal>
  );
}; 